// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uRb_","col":"styles_col__2SGHU"};